import './style.scss';
import {Box, IconButton, Slider, Stack, SvgIcon} from "@mui/material";
import {ReactComponent as IconMinus} from '../../../lib/icons/LoanIcon_minus.svg';
import {ReactComponent as IconPlus} from '../../../lib/icons/LoanIcon_plus.svg';

function InputPeriodSlider({value, handler, from, to, defaultValue, step}) {
    value = parseInt(value);
    from = parseInt(from);
    to = parseInt(to);
    defaultValue = parseInt(defaultValue);
    step = parseInt(step);
    const handleChange = (event, newValue) => {
        handler(newValue);
    };

    const valuetext = (value) => {
        return `${value} YEARS`;
    }

    const handleMinus = () => {
        if (value > from) {
            handler(value - step);
        }
    }

    const handlePlus = () => {
        if (value < to) {
            handler(value + step);
        }
    }

    return <Box className="calc-input-slider">
        <Stack spacing={2} direction="row" alignItems="center">
            <IconButton className="calc-input-pm-icon" aria-label="Period minus control"
                        onClick={handleMinus}>
                <SvgIcon component={IconMinus} viewBox="0 0 200 200"/>
            </IconButton>
            <Slider
                onChange={handleChange}
                value={value}
                aria-label="Always visible"
                defaultValue={defaultValue}
                step={step}
                marks
                min={from}
                max={to}
                valueLabelDisplay="on"
                valueLabelFormat={valuetext}
            />
            <IconButton className="calc-input-pm-icon" aria-label="Period plus control"
                        onClick={handlePlus}>
                <SvgIcon component={IconPlus} viewBox="0 0 200 200"/>
            </IconButton>
        </Stack>
        <Box className="calc-input-slider-min-max">
            <div>{`${from} YEAR`}</div>
            <div>{`${to} YEARS`}</div>
        </Box>
    </Box>
}

export default InputPeriodSlider;